<ng-template #loading>
    <edp-loader [size]="'md'" class="text-center my-auto"></edp-loader>
</ng-template>

<form
    [formGroup]="consumptionsForm"
    (ngSubmit)="onSubmit()"
    class="h-100 p-0
    d-flex flex-column"
    *ngIf="activeMetersGas; else loading"
>
    <div class="form-row">
        <div class="form-group col-4 mb-0">
            <label class="font-weight-bold">{{ "pt.edp.edponline.dashboard.widget.consumptions.typeLT" | translate }}</label>
            <input
                type="text"
                inputmode="numeric"
                min="0"
                [ngClass]="{
                    'input-alert': meterGas.OutsideConsumption,
                    'input-error': consumptionsForm.controls['typeLT'].invalid && !consumptionsForm.controls['typeLT'].errors?.required
                }"
                class="form-control"
                formControlName="typeLT"
                (change)="consumptionsFormChange($event)"
            />
            <small class="form-text" *ngIf="activeMetersGas.lastInserted?.LT && !noConsumptionData">
                {{ "pt.edp.edponline.last" | translate }} :
                {{ activeMetersGas.lastInserted.LT }}
            </small>
        </div>
        <ng-container *ngIf="showAlertMessage && !isTypeMeterError">
            <small class="message-alert mt-2">
                {{ "pt.edp.edponline.dashboard.widget.consumptions.outSideConsumptions" | translate }}
            </small>
        </ng-container>
        <ng-container *ngIf="isTypeMeterError">
            <small class="message-error mt-2">{{ "pt.edp.edponline.dashboard.widget.consumptions.error" | translate }}</small>
        </ng-container>
    </div>
    <div class="mb-2 mt-auto pt-4 d-flex justify-content-center">
        <button impersonateDisable [disabled]="!consumptionsForm.valid || isSubmitted" class="btn btn-primary w-75">
            <span *ngIf="!activeMetersGas?.updateReadingInTime && !activeMetersGas?.updateReadingOutTime">
                {{ "ContractReadings.sendreading" | translate }}
            </span>
            <span *ngIf="activeMetersGas?.updateReadingInTime || activeMetersGas?.updateReadingOutTime">
                {{ "pt.edp.edponline.dashboard.widget.consumptions.updateConsumptions" | translate }}
            </span>
        </button>
    </div>
</form>
